import PropTypes from "prop-types";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import "./styles.scss";

export const SVGLeft = () => (
  <svg
    style={{
      height: "156px",
      left: "-70px",
      top: "-115px",
      width: "79px",
    }}
    id="deco-left-arc-cyan"
    width="79"
    height="156"
    viewBox="0 0 79 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M79 0C35.3477 0.124087 7.8281e-06 34.9983 5.94844e-06 78C4.06878e-06 121.002 35.3477 155.876 79 156L79 120.566C55.2273 120.442 35.9941 101.432 35.9941 78C35.9941 54.5679 55.2273 35.5579 79 35.4341L79 0Z"
      fill="#81FFFF"
    />
  </svg>
);

export const SVGRight = () => (
  <svg
    style={{
      height: "248px",
      width: "248px",
      right: "-74px",
      bottom: "-180px",
    }}
    id="deco-full-circle-rose"
    width="248"
    height="248"
    viewBox="0 0 248 248"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle r="124" transform="matrix(1 0 0 -1 124 124)" fill="#FAB8C4" />
  </svg>
);

export const Background = ({ isNarrow }) => (
  <div
    className={classNames("svg-background", {
      "max-w-[450px]": isNarrow,
      "max-w-[520px]": !isNarrow,
    })}
  >
    <SVGLeft />
    <SVGRight />
  </div>
);
Background.propTypes = {
  isNarrow: PropTypes.bool,
};
